import React from 'react'
import { ReactComponent as LogoPic } from 'assets/logo.svg'

import styles from './styles.module.scss'


export const Logo =
  ({ className }) =>
      <LogoPic className={styles.logo} />
